import { MiniUsersResponseInterface } from "../users/users-response.interface";
import { MonitoringsResponseInterface } from "../monitorings/monitorings-response.interface";
import { CategoryTypes } from "../../utils/enums.utils";
import { AttachmentsResponseInterface } from "@crm/interface";

export interface SalesResponseInterface {
  id: string;
  quarter: SalesQuarters;
  status: SalesStatus;
  category: CategoryTypes;
  po_number: string | null;
  invoice_number: string | null;
  dr_number: string | null;
  sales_remark: string | null;
  created_at: string | null;
  updated_at: string | null;
  created_by: MiniUsersResponseInterface | null;
  updated_by: MiniUsersResponseInterface | null;
  monitoring: MonitoringsResponseInterface;
  attachments: SaleAttachmentsResponseInterface[] | null;
}

export interface SaleAttachmentsResponseInterface {
  sales_id: string;
  attachment: AttachmentsResponseInterface;
  status: SalesAttachmentsStatus;
}
  
export enum SalesAttachmentsStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}

export enum SalesStatus {
  IN_PROGRESS = 'In Progress',
  PO_FOLLOW_UP = 'PO to Follow',
  DELIVERED = 'Delivered',
  COLLECTED = 'Collected',
  DELETED = 'Deleted',
}

export enum SalesQuarters {
  Q1 = 'Q1',
  Q2 = 'Q2',
  Q3 = 'Q3',
  Q4 = 'Q4'
}